import { render, staticRenderFns } from "./Fibs.vue?vue&type=template&id=bdd46c86&"
import script from "./Fibs.vue?vue&type=script&lang=js&"
export * from "./Fibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports